// removed by extract-text-webpack-plugin
module.exports = {"BuildControls":"BuildControls__BuildControls__220uz","OrderButton":"BuildControls__OrderButton__1ScSk","enable":"BuildControls__enable__3XAWA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BuildControls/BuildControls.css
// module id = 143
// module chunks = 3